<template>
  <div
    class="article-item"
    @click="
      articleJumpLink({
        id,
        articleType,
        target,
        redirectLink,
        source: source || '',
      })
    "
  >
    <div class="like-wrap" v-if="showLikes">
      <div class="like-content">
        <em class="ico align-center" :style="getIcoOfBg('likeicon')"></em>
        <span class="num align-center">{{ likeTotal }}</span>
      </div>
    </div>
    <div
      class="article-item-left"
      :style="pic1 ? setBg(pic1) : getIcoOfBg('newslistpic')"
    ></div>
    <div class="article-item-right">
      <a-typography-paragraph
        class="text"
        :ellipsis="ellipsis"
        :content="title"
      ></a-typography-paragraph>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { setBg } from '@utiles/index';
import useArticleJumpLink from '@hooks/useArticleJumpLink';
import { getIcoOfBg } from '@config/siteConfig';
import { Typography } from 'ant-design-vue';
const props = defineProps({
  showLikes: {
    default: 0,
  },
  articleItemInfo: {
    required: true,
  },
  source: {
    default: '',
  },
});

const ellipsis = {
  rows: 3,
  expandable: false,
  onEllipsis: (e: boolean) => {
    console.log(e);
  },
};

const {
  PIC1: pic1,
  PIC2: pic2,
  TITLE: title,
  ARTICLE_GROUP_ID: id,
  REDIRECT_LINK: redirectLink,
  REDIRECT_TYPE: target,
  LIKE_TOTAL: likeTotal,
  ARTICLE_TYPE: articleType,
} = props.articleItemInfo;

const { articleJumpLink } = useArticleJumpLink();
</script>

<style lang="scss" scoped>
@import '@assets/scss/dimen.scss';
@import '@assets/scss/mixin.scss';
.article-item {
  position: relative;
  display: flex;
  background: $layercolor;
  width: 100%;
  height: 174px;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 14px;
  margin-bottom: 20px;
  cursor: pointer;
  @include addTouchEffect();
  .article-item-left {
    width: 154px;
    height: 135px;
    margin-right: 20px;
    flex-shrink: 0;
    border-radius: 14px;
  }
  .article-item-right {
    position: relative;
    width: 376px;
    flex: 1;
    height: 97px;
    .text {
      width: 100%;
      height: 100%;
      line-height: 30px;
      white-space: pre-wrap;
      font-size: $fzNormal;
      color: $itemcolor;
      overflow: hidden;
    }
  }

  .like-wrap {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: $fzSmall;
    color: $tipscolor;
    .ico {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin-right: 5px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .article-item {
    height: calc(174px / $pcRate);
    padding: calc(20px / $pcRate);
    border-radius: calc(14px / $pcRate);
    margin-bottom: calc(20px / $pcRate);
    .article-item-left {
      width: calc(154px / $pcRate);
      height: calc(135px / $pcRate);
      margin-right: calc(20px / $pcRate);
      border-radius: calc(14px / $pcRate);
    }
    .article-item-right {
      width: calc(376px / $pcRate);
      height: calc(97px / $pcRate);
      .text {
        line-height: calc30(px / $pcRate);
        font-size: $fzNormalPc;
      }
    }

    .like-wrap {
      bottom: calc(20px / $pcRate);
      right: calc(20px / $pcRate);
      font-size: $fzSmallPc;

      .ico {
        width: calc(17px / $pcRate);
        height: calc(17px / $pcRate);
        margin-right: calc(5px / $pcRate);
      }
    }
  }
}
</style>
